// Unpublished Work © 2021-2026 Deere & Company.

import t from 'tcomb';
import {Customer} from '../customer';
import {EquipmentDetails} from './equipment-details';
import {PageStatus} from '../page-status';
import {CrossReferences} from './cross-references';
import {LogHistory} from './log-history';
import {RemoveVisibilityError} from './removeVisibilityError';
import {DeleteContact} from './delete-contact';
import {MergeContact} from './merge-contact';
import {DigitalUserAccountDetails} from './digital-user-account-details';

export const CustomerProfile = t.struct({
    contacts: t.list(Customer),
    customer: t.maybe(Customer),
    equipmentDetails: EquipmentDetails,
    digitalUserAccountDetails: DigitalUserAccountDetails,
    crossReferences: CrossReferences,
    logHistory: LogHistory,
    pageStatus: PageStatus,
    removeVisibilityError: RemoveVisibilityError,
    isCustomerVisibilityRemoved: t.Boolean,
    deleteBusinessContacts: DeleteContact,
    mergeBusinessContacts: MergeContact
}, {
    defaultProps: {
        contacts: [],
        crossReferences: new CrossReferences({}),
        customer: null,
        equipmentDetails: new EquipmentDetails({}),
        digitalUserAccountDetails: new DigitalUserAccountDetails({}),
        logHistory: new LogHistory({}),
        pageStatus: PageStatus.meta.map.COMPLETE,
        removeVisibilityError: new RemoveVisibilityError({}),
        isCustomerVisibilityRemoved: false,
        deleteBusinessContacts: new DeleteContact({}),
        mergeBusinessContacts: new MergeContact({})
    },
    name: 'CustomerProfile',
    strict: true
});
